import { createReducer } from "@reduxjs/toolkit";

import { initialState, setWorkFlowStages } from "../Actions/jobWorkFlowActions";

import type { WorkFlowStages } from "../Actions/jobWorkFlowActions";

export const jobWorkFlowReducer = createReducer<WorkFlowStages>(initialState, (builder) => {
    builder.addCase(setWorkFlowStages, (state, action) => {
        state.WorkFlowStages = action.payload;
    });
});